import { gql } from "@apollo/client";

export const DROPDOWN_LIST_PGA_FORM = gql`
  fragment dropdownListPGAForm on SelectedListDto {
    id
    name
    minYear
    maxYear
  }
`;

export const FRAGMENT_PRICING_LIST_DTO = gql`
  fragment dropdownListPricing on PricingListDto {
    id
    code
    descr
    species
    type
  }
`;
